import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';

type AdminGuardProps = {
  children: React.ReactNode;
};

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { isLoaded, isAdmin } = useAuthContext();

  if (!isLoaded) return null;

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
        <div className="max-w-md">
          <h1 className="text-2xl font-bold text-gray-800 mb-3">Access Denied</h1>
          <p className="text-gray-600">
            This page is only accessible to administrators. If you believe you
            should have access, please contact your system administrator.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminGuard;
